module.exports = __webpack_public_path__ + "static/media/MD_TutorialSlides_10202020_12_EQ.38610dd0.png";